export default "__VITE_ASSET__DA$O8i0z__"